<template>
  <div class="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100 position-relative">
    <div class="bg-overlay position-absolute top-0 start-0 w-100 h-100"></div>

    <!-- Imagen de fondo -->
    <div class="background-image position-absolute top-0 start-0 w-100 h-100" style="background-image: url('http://dmbgroup.online/wp-content/uploads/2025/07/DMG_GO-389-scaled.jpg'); background-size: cover; background-position: center; opacity: 0.2; z-index: 0;"></div>

    <div class="card shadow-lg rounded-4 overflow-hidden w-100" style="max-width: 920px; z-index: 10;">
      <div class="row g-0">

        <!-- LADO IZQUIERDO (FRASES + FONDO) -->
        <div class="col-md-6 d-none d-md-block bg-dark position-relative">
          <div class="h-100 p-4 d-flex flex-column justify-content-between text-white position-relative" style="background-image: linear-gradient(to bottom, rgba(17, 70, 35, 0.6), rgba(0,0,0,0.6)), url('https://i0.wp.com/dmbgroup.online/wp-content/uploads/2023/06/DMB2023-TEAM-scaled-e1686070690656.jpg?fit=2560%2C1344&ssl=1'); background-size: cover; background-position: center;">
            <div class="text-center">
              <img src="@/assets/images/logo-light.png" alt="Logo" height="100" class="mb-4 mx-auto d-block">
            </div>
            <div class="text-center small text-white-50">DMB Insurance Agency</div>
          </div>
        </div>

        <!-- LADO DERECHO (ANIMACIÓN + MENSAJE) -->
        <div class="col-md-6 bg-white p-5 text-center">
          <lottie
              colors="primary:#405189,secondary:#08a88a"
              :options="defaultOptions"
              :height="180"
              :width="180"
          />

          <div class="mt-4">
            <h5>You are Logged Out</h5>
            <p class="text-muted">Thank you for using <span class="fw-semibold">CRM</span></p>
            <router-link to="/login" class="btn btn-success w-100 mt-3">Sign In</router-link>
          </div>
        </div>

      </div>
    </div>

    <!-- Footer -->
    <footer class="footer position-absolute bottom-0 w-100">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <p class="mb-0 text-white small">&copy; {{ new Date().getFullYear() }} DMB Insurance Agency. Crafted with <i class="mdi mdi-heart text-danger"></i></p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import animationData from "@/components/widgets/hzomhqxz.json";
import Lottie from "@/components/widgets/lottie.vue";

export default {
  name: "Logout",
  data() {
    return {
      defaultOptions: { animationData: animationData },
    };
  },
  components: {
    lottie: Lottie,
  },
  mounted() {
    localStorage.removeItem("jwt");
    localStorage.removeItem("id");
    localStorage.removeItem("selectedUserName");
    localStorage.removeItem("email");
    localStorage.removeItem("lastname");
    localStorage.removeItem("firstName");
    localStorage.removeItem("clientFormData");
    localStorage.removeItem("completeForm");
    localStorage.removeItem("language");
    localStorage.removeItem("nightMode");
    localStorage.removeItem("selectedUser");
    this.$store.commit("removeToken");
  },
};
</script>

<style scoped>
.auth-page-wrapper {
  background: linear-gradient(to bottom right, #75d26e, #ffffff);
  position: relative;
  overflow: hidden;
}
.bg-overlay {
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.background-image {
  z-index: 0;
}
</style>
